import { prefix } from '../module';

export const THREADS_FETCHED = prefix('THREADS_FETCHED');
export const ALL_THREADS_LOADED = prefix('ALL_THREADS_LOADED');
export const THREAD_MARKED_READ = prefix('THREAD_MARKED_READ');
export const THREAD_MARKED_UNREAD = prefix('THREAD_MARKED_UNREAD');
export const THREAD_SELECTED = prefix('THREAD_SELECTED');
export const THREAD_CREATED = prefix('THREAD_CREATED');
export const THREAD_SUBJECT_EDITING = prefix('THREAD_SUBJECT_EDITING');
export const THREAD_SUBJECT_DRAFT_UPDATED = prefix('THREAD_SUBJECT_DRAFT_UPDATED');
export const THREAD_SUBJECT_UPDATED = prefix('THREAD_SUBJECT_UPDATED');
export const THREAD_POSTED = prefix('THREAD_POSTED');
export const THREAD_REMOVED = prefix('THREAD_REMOVED');
export const THREAD_UPDATED = prefix('THREAD_UPDATED');
export const VIEW_MODE_SET = prefix('VIEW_MODE_SET');

export const THREAD_DRAFT_CREATED = prefix('THREAD_DRAFT_CREATED');
export const THREAD_DRAFT_REMOVED = prefix('THREAD_DRAFT_REMOVED');
export const THREAD_DRAFT_UPDATED = prefix('THREAD_DRAFT_UPDATED');
